
    import '/home/ec2-user/Youlify-Design/components/anchor/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["anchor-demo-basic","anchor-demo-horizontal","anchor-demo-static","anchor-demo-onclick","anchor-demo-customizehighlight","anchor-demo-targetoffset","anchor-demo-onchange","anchor-demo-replace","anchor-demo-legacy-anchor","anchor-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/anchor/index.zh-CN.md?type=demo')
};